/* global G */
import { setKey } from 'lib/util'
import getLogPayload from 'app/_shared/events/log/getPayload'
import submit from 'app/_shared/events/log/submit'

/**
 * Sends a log request to the server for the current resource.
 *
 * NOTE: Although this handler calls async functions to make the request, it
 * itself is not async, we don't want to wait for the request to be finished.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {string|null} modelType
 * @returns {function(*, ...[*]): *[]}
 */
const logAccess = (module, modelType) => (components, ...args) => {
  const [data = {}] = args || []
  const actionState = module[G.STATE][G.ACTION][G.STATE]
  const settingsAdapter = module[G.ADAPTER][G.SETTINGS]

  // TODO: Checking for user setting, which doesn't exist yet, remove defaulting to
  //       `true` once it does
  const enableStatistics = settingsAdapter[G.API].get({ key: 'enableStatistics' }) || true

  if (enableStatistics) {
    const payload = /** @type {LogPayload} */ getLogPayload(
      module,
      null,
      { detail: { data: { ...data, type: data.type || modelType } } },
    )

    if (!actionState.isLogged || !!payload?.term) {
      submit(module, null, { detail: { payload } })
    }

    setKey(true, 'isLogged', actionState)
  }

  return [components, ...args]
}

export const logTypeAccess = type => module => logAccess(module, type)

export default logAccess
